import React from "react";
import TopHeader from "./TopHeader";

import { SideBar } from "./SideBar";
import { useLocation } from "react-router-dom";
import Sidebar2 from "./Sidebar2";
import BreadcrumbItem from "../../Common/BreadcrumbItem";
// import { Confirm505Err } from "../components/Confirm505Err";

interface iPageTemplate {
  title?: string;
  children?: React.ReactElement;
}

export function PageTemplate({ title, children }: iPageTemplate) {
  const location = useLocation();

  const body = document?.querySelector("body");
  const closeMenu = () => {
    body!.classList.remove("vertical-sidebar-enable");
  };

  const isFluid =
    location.pathname === "/admin/news/create" ||
    location.pathname === "/admin/tests/create" ||
    location.pathname.includes("admin/news/update/") ||
    location.pathname.includes("admin/tests/update/");

  return (
    <>
      {/* <Confirm505Err /> */}
      <div id="layout-wrapper">
        <TopHeader />
        {/* <MainHeader /> */}
        <Sidebar2 />
        {/* <div className="vertical-overlay" onClick={closeMenu}></div> */}


        <div className="pc-container">
          <div className="pc-content">
            {/* [ breadcrumb ] start */}
            <div className="page-header">
              <div className="page-block">
                <div className="row align-items-center">
                  <div className="col-md-12">
                    {/* <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <a href="../dashboard/index.html">Home</a>
                      </li>
                      <li className="breadcrumb-item">
                        <a href="javascript: void(0)">Dashboard</a>
                      </li>
                      <li className="breadcrumb-item" aria-current="page">

                      </li>
                    </ul> */}
                  </div>
                  <div className="col-md-12">
                    <div className="page-header-title">
                    
                      <h2 className="mb-0">{title}</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* [ breadcrumb ] end */}
            {/* [ Main Content ] start */}
            {children}
            {/* [ Main Content ] end */}
          </div>
        </div>
      </div>
    </>
  );
}



